import script from "./units-list.vue?vue&type=script&setup=true&lang=js"
export * from "./units-list.vue?vue&type=script&setup=true&lang=js"

import "./units-list.vue?vue&type=style&index=0&id=7d4a916c&lang=scss&scoped=true"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d4a916c"]])

export default __exports__